import React, { useEffect } from 'react';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  ariaLabel: string;
  children: React.ReactNode;
  // Overrides the card's default 480px cap (see .chat-modal-card) for content
  // that needs more room, e.g. an image preview. Omit to keep the default.
  maxWidth?: number;
}

// Generic backdrop + centered card shell used by FocusPanel and FileUploadPanel.
// Deliberately has no header/title/close button of its own — each panel keeps
// its own content and close affordance; this only owns the overlay mechanics
// (backdrop click, Escape key) and positioning.
const Modal: React.FC<ModalProps> = ({ isOpen, onClose, ariaLabel, children, maxWidth }) => {
  useEffect(() => {
    if (!isOpen) return;
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div
      className="chat-modal-overlay"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div
        className="chat-modal-card"
        style={maxWidth ? { maxWidth } : undefined}
        role="dialog"
        aria-modal="true"
        aria-label={ariaLabel}
      >
        {children}
      </div>
    </div>
  );
};

export default Modal;
